import { jsx as _jsx } from "react/jsx-runtime";
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { TextField, InputAdornment, IconButton } from '@mui/material';
import { useState } from 'react';
export const PasswordField = ({ value, onChange, label, id, required = false, testId = '', error = false, helperText = '', }) => {
    const [showPassword, setShowPassword] = useState(false);
    const handleClickShowPassword = () => setShowPassword(!showPassword);
    return (_jsx(TextField, { variant: "outlined", margin: "normal", required: required, fullWidth: true, name: "password", label: label, type: showPassword ? 'text' : 'password', id: id, autoComplete: "current-password" // Helps autofill in browsers
        , value: value, onChange: onChange, error: error, helperText: helperText, InputProps: {
            endAdornment: (_jsx(InputAdornment, Object.assign({ position: "end" }, { children: _jsx(IconButton, Object.assign({ "aria-label": showPassword ? 'Hide password' : 'Show password', edge: "end", onClick: handleClickShowPassword }, { children: showPassword ? _jsx(VisibilityOff, {}) : _jsx(Visibility, {}) })) }))),
        }, inputProps: {
            'data-testid': testId,
            'aria-label': 'Password', // Descriptive label for screen readers
        } }));
};
